import { partnerSaveActions, getAllUserByRoleRmActions } from "./actions";

const initialState = {
  partnerDetails: null,
  rmUserList: [],
  isRMLoading: false,
};

const partnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case partnerSaveActions.SAVE_PARTNER_INFO_SUCCESS:
      return {
        ...state,
        partnerDetails: action.payload.data,
      };
    case partnerSaveActions.SAVE_PARTNER_INFO_ERROR:
      return {
        ...state,
        partnerDetails: [],
      };
    case getAllUserByRoleRmActions.GET_ALL_USER_BY_ROLE_RM_LOADING:
      return {
        ...state,
        isRMLoading: true,
      };
    case getAllUserByRoleRmActions.GET_ALL_USER_BY_ROLE_RM_SUCCESS:
      return {
        ...state,
        rmUserList: action.payload?.data?.rmUserRole,
        isRMLoading: false,
      };
    case getAllUserByRoleRmActions.GET_ALL_USER_BY_ROLE_RM_ERROR:
      return {
        ...state,
        rmUserList: [],
        isRMLoading: false,
      };

    default:
      return state;
  }
};

export default partnerReducer;
